import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import AccountsPage from "./pages/AccountsPage";
import OpportunitiesPage from "./pages/OpportunitiesPage";
import ActivitiesPage from "./pages/ActivitiesPage";
import PipelinePage from "./pages/PipelinePage";
import UsersPage from "./pages/UsersPage";
import NILResourcesPage from "./pages/NILResourcesPage";
import AvailabilityReportsPage from "./pages/AvailabilityReportsPage";
import PublicResourcesPage from "./pages/PublicResourcesPage";
import ResourceLeadsPage from "./pages/ResourceLeadsPage";
import InsuranceHomePage from "./pages/InsuranceHomePage";
import QuoteFormPage from "./pages/QuoteFormPage";
import TeamworksLandingPage from "./pages/TeamworksLandingPage";
import PerformanceBonusFormPage from "./pages/PerformanceBonusFormPage";
import TransferFormPage from "./pages/TransferFormPage";
import QuotePipelinePage from "./pages/QuotePipelinePage";
import Layout from "./components/Layout";
import "./App.css";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center">
        <div className="animate-pulse-slow text-[#007AFF] text-xl font-semibold">Loading...</div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center">
        <div className="animate-pulse-slow text-[#007AFF] text-xl font-semibold">Loading...</div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  if (!user.is_admin) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/resources" element={<PublicResourcesPage />} />
          <Route path="/nil" element={<TeamworksLandingPage />} />
          <Route path="/insurance" element={<InsuranceHomePage />} />
          <Route path="/quote" element={<QuoteFormPage />} />
          <Route path="/quote-performance-bonus" element={<PerformanceBonusFormPage />} />
          <Route path="/quote-transfer" element={<TransferFormPage />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/dashboard" element={<DashboardPage />} />
                    <Route path="/pipeline" element={<PipelinePage />} />
                    <Route path="/accounts" element={<AccountsPage />} />
                    <Route path="/opportunities" element={<OpportunitiesPage />} />
                    <Route path="/activities" element={<ActivitiesPage />} />
                    <Route path="/nil-resources" element={<NILResourcesPage />} />
                    <Route path="/availability-reports" element={<AvailabilityReportsPage />} />
                    <Route path="/resource-leads" element={<ResourceLeadsPage />} />
                    <Route path="/quote-pipeline" element={<QuotePipelinePage />} />
                    <Route path="/users" element={
                      <AdminRoute>
                        <UsersPage />
                      </AdminRoute>
                    } />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster position="top-right" theme="light" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
